/**
 * ກັບ yyyy-MM-DD ຈາກຈຸດເວລາ ຫຼື ສະຕຣິງວັນທີ ສໍາລັບ attribute `value` ຂອງ `<input type="date">`.
 */
export function toDateInputValue(raw: string | null | undefined): string {
  if (raw == null) return "";
  const s = String(raw).trim();
  if (!s) return "";
  const m = /^(\d{4}-\d{2}-\d{2})/.exec(s);
  return m?.[1] ?? "";
}
